import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Dropdown, Table } from 'semantic-ui-react';
import i18next from 'i18next';
import moment from 'moment';

import { DataGrid, DateRangePicker } from '../../common';
import { fetchBudgetReport } from '../../../actions';
import { formatPrice } from '../../../helpers/format';
import { getCurrentPeriod } from '../../../helpers/company';

class BudgetReport extends Component {
    state = {
        companyId: this.props.company.id,
        startDate: moment().subtract(1, 'month').startOf('day'),
        endDate: moment().endOf('day'),
        grouping: 'byPayments'
    };

    constructor(props) {
        super(props);

        this.renderDateSelection = this.renderDateSelection.bind(this);
    }

    componentWillMount() {
        const period = getCurrentPeriod(this.props.company ? this.props.company.monthlyCycleStartDay : 1);
        const startDate = moment(period[0]).startOf('day');
        const endDate = moment(period[1]).startOf('day');
        this.setState({ startDate, endDate }, () => {
            if (this.state.companyId) {
                this.props.fetchBudgetReport(this.state);
            }    
        });
    }

    renderDateSelection() {
        const { fetchBudgetReport } = this.props;
        const groupingOptions = [
            { value: 'byPayments', text: i18next.t('grouping.byPayments') },
            { value: 'byUsers', text: i18next.t('grouping.byUsers') }
        ];

        return (
            <Form>
                <Form.Group>
                    <Form.Field>
                        <DateRangePicker
                            value={[this.state.startDate, this.state.endDate]}
                            onChange={(rangeDates) => this.setState(
                                { startDate: rangeDates[0].startOf('day'), endDate: rangeDates[1].endOf('day') },
                                () => fetchBudgetReport(this.state)
                            )}
                           
                            enableFutureDate
                        />
                    </Form.Field>
                    <Form.Field>
                        <Dropdown
                            compact
                            selection
                            options={groupingOptions}
                            value={this.state.grouping}
                            onChange={(e, { value }) => this.setState({ grouping: value }, () => fetchBudgetReport(this.state))}
                        />
                    </Form.Field>
                </Form.Group>
            </Form>
        );
    }

    render() {
        const { company, budgetReport } = this.props;

        let columns = [{
            Header: i18next.t('createDate'),
            accessor: 'createdAt',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date(),
            Footer: (<span>{i18next.t('total')}</span>)
            // footerData: i18next.t('total')
        }, {
            Header: i18next.t('name'),
            accessor: 'username',
            filterable: true
        }, {
            Header: i18next.t('restaurant'),
            accessor: 'restaurant.name',
            filterable: true
        }, {
            id: 'dailyLimit',
            Header: i18next.t('dailyLimit'),
            accessor: row => formatPrice(row.dailyLimit, company.currencyCode),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 }
        }, {
            id: 'monthlyLimit',
            Header: i18next.t('monthlyLimit'),
            accessor: row => formatPrice(row.monthlyLimit, company.currencyCode),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 }
        }, {
            id: 'budget',
            Header: i18next.t('budget'),
            accessor: row => formatPrice(row.amount, company.currencyCode),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 },
            Footer: (<span>
                {formatPrice(budgetReport.reduce((total, row) => total + row.amount, 0), company.currencyCode)}
            </span>)
            // footerData: formatPrice(budgetReport.reduce((total, row) => total + row.amount, 0), company.currencyCode)
        }, {
            id: 'amount',
            Header: i18next.t('amount'),
            accessor: row => formatPrice(row.totalAmount, company.currencyCode),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 },
            Footer: (<span>
                {formatPrice(budgetReport.reduce((total, row) => total + row.totalAmount, 0), company.currencyCode)}
            </span>),
            // footerData: formatPrice(budgetReport.reduce((total, row) => total + row.totalAmount, 0), company.currencyCode)
        }];

        if (this.state.grouping === 'byUsers') {
            columns = columns.slice(1);
            columns.splice(1, 1);
        }

        return (
            <div style={{ padding: 10 }}>

                <DataGrid
                    data={budgetReport}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        if (typeof rowInfo !== "undefined") {
                            return {};
                        }
                        return {};
                    }}
                    extraActions={this.renderDateSelection()}
                    paginated
                   
                />

            </div >
        );
    }
}

BudgetReport.propTypes = {
    company: PropTypes.object,
    fetchBudgetReport: PropTypes.func,
    budgetReport: PropTypes.array,
    
};

const mapStateToProps = (state, ownProps) => {
    const { budgetReport } = state.budgetsApp.reports;

    return { budgetReport };
};

export default connect(mapStateToProps, { fetchBudgetReport })(BudgetReport);
